const en = {
  online_airport_board: "Online airport board",
  scoreboard: "Scoreboard",
  services: "Services",
  location_map: "Our location on the map",
  location: "Our location on the map",
  location_text: "A-105, 40th kilometer, 3, Domodedovo urban district, Moscow region, 142034",
  contact_address: "142046, Moscow region, Domodedovo urban district, 40 km of highway A-105, bld.3, office №88",
  address: "Address",
  agreement_text:
    "By logging into the site, you agree to the Privacy Policy and the rules for the collection and processing of personal data",
  login_title_text: "Login to your account",
  login_text: "Login",
  password_text: "Password",
  forgot_password_text: "Forgot your password?",
  reset_password_text: "You can reset it here",
  registration_text: "Register",
  enter_text: "Sign in",
  new_customer: "New Customer?",
  logged_user_text: "Already have an account?",
  invalid_password: "6 characters minimum",
  invalid_email: "Invalid Email",
  required: "Required field",
  travel_time: "Travel time",
  flight: "Flight",
  flights: "Flights",
  terminal: "Terminal",
  baggage: "Baggage",
  hand_luggage: "Hand luggage",
  refund_ticket: "Ticket refund",
  change: "Ticket exchange",
  no_refund: "Non-refundable",
  yes_refund: "Refundable ticket",
  no_change: "No ticket exchange",
  yes_change: "Exchange ticket",
  yes_baggage: "Baggage",
  no_baggage: "No baggage",
  yes_hand_luggage: "Hand luggage",
  no_hand_luggage: "No hand luggage",
  show_rules: "Show rules",
  total: "Total",
  passengers: "Passengers",
  select_from_list: "Select from list",
  name_as_in_document: "First name as in the document",
  middlename_as_in_document: "Middle name as in the document",
  surname_as_in_document: "Last name as in the document",
  date_of_birth: "Date of Birth",
  gender: "Gender",
  citizenship: "Citizenship",
  age: "Age",
  document: "Document",
  payer: "Payer",
  for_payer_mess:
    "We will send booking information to your Email. Phone is needed for urgent alerts when schedule changes ",
  series_and_number: "Document number",
  valid_until: "Expiration date",
  airline_bonus_card: "Airline Bonus Card",
  number_bonus_card: "Bonus card number",
  phone_number: "Phone number",
  contact_number: "+998 97 985 00 06 (every day from 9:00 to 23:00)",
  email: "Email",
  workH: "Working hours",
  working_hours: "on weekdays from 10:00 to 17:00",
  how_to_read_rules: "How to read fare rules",
  tariff_rules: "Fare rules",
  book_and_proceed_to_payment: "Book and proceed to payment",
  agreement_book_text: "By pressing “Book and proceed to payment” you accept to",
  agreement_book_link: "the airline fare rules",
  everywhere_local_time: "Everywhere indicated local time of departure and arrival",
  duration: "duration",
  in: "in",
  no_data_contact_technical_support: "No data. Contact technical support.",
  back_to_orders: "Back to orders",
  incorrect_date_from_adt: "Invalid date for adult",
  incorrect_date_from_chd: "Invalid date for child",
  incorrect_date_from_inf: "Invalid date for infant",
  incorrect_date: "Invalid date",
  check_date_and_change_doc: "Check date of birth or change document type",
  warning_inf_date: "The airline may ask a newborn's certificate of admission to flight",
  ps_should_be_10_digits: "The Russian national passport consists of 10 digits",
  psp_should_be_9_digits: "The Russian international passport consists of 9 digits",
  incorrect_doc_number: "Invalid document number",
  hint_for_ps_doc: "Enter passport number as 1234567890",
  hint_for_psp_doc: "Enter passport number as 123456789",
  hint_for_sr_doc: "Enter birth certificate number as IXЯЯ123456",
  hint_for_np_doc: "Enter document number",
  male: "Male",
  female: "Female",
  russian_passport: "Russian national passport",
  birth_certificate: "Russian birth certificate",
  international_passport: "Russian international passport",
  foreign_document: "Foreign document",
  national_passport_id_card: "National passport (ID card)",
  domestic_birth_certificate: "Birth certificate",
  place_one: "place",
  place_more: "places",
  place_many: "places",
  customer_support: "Customer support",
  financial_matters: "Financial questions",
  agreement_footer_text: "Use of materials is prohibited without written consent ",
  flight_schedule: "Flight schedule",
  offer: "Offer",
  question_answer: "F.A.Q.",
  jobs: "Jobs",
  facebook: "Facebook",
  about_us: "About us",
  currency: "Currency",
  language: "Language",
  search: "Search",
  personal_info: "Personal data",
  personal_area: "Personal account",
  not_found_page: "The page you tried to open was not found",
  to_main: "To home page",
  log_out: "Logout",
  session: "Session",
  error_500_text:
    "It seems something went wrong, but we already know about the problem and are working to fix it. We apologize for the inconvenience. ",
  lang_ru: "Russian",
  lang_tj: "Tajik",
  lang_en: "English",
  balance: "Balance",
  otb: "Balance",
  own_funds: "Own funds",
  credit_balance: "Credit balance",
  credit_line: "Credit line",
  no: "No",
  for_route: "For route",
  to_result_search: "To search results",
  only_a_z_space: "Latin symbols and space only",
  only_a_z: "Latin symbols only",
  invalid_phone: "Wrong phone number",
  min_2_symbol: "2 characters minimum",
  select_value_from_list: "Select value from the list",
  check_date: "Check the date",
  incorrect_number: "Invalid card number",
  incorrect_cvc: "Invalid code",
  incorrect_card_holder: "Invalid card holder name",
  incorrect_card_month: "Invalid month",
  incorrect_card_year: "Invalid year",
  code: "Сode",
  message: "Message",
  close: "Close",
  error_message_part_1:
    "It seems something went wrong. For our understanding causes of the problem, please contact tech support",
  error_message_part_2: "and tell the session number",
  error_message_part_3: "After closing the message, you will redirected to the main page of the service. ",
  choose: "Select",
  collapse: "Collapse",
  looking_tickets: "We're searching tickets",
  wait_please: "Please, wait",
  we_issue_tickets: "We're issuing tickets, it doesn't take too much time",
  created: "Created",
  left: "Left",
  less_than_minute: "less than a minute",
  help: "Help",
  exchange_and_return_rules: "Exchange and return: rules",
  after_flight: "After the flight",
  go_to_section: "Go to section",
  next: "Next",
  earlier: "Previous",
  not_book_tickets: "You have no booked orders",
  route_from: "From",
  route_to: "To",
  date_from: "Date",
  date_to: "Return date",
  find: "Search",
  add_route: "Add flight",
  one_way: "One way",
  two_way: "Round trip",
  multi_way: "Multiple flight",
  economy: "Economy",
  business: "Business",
  first: "First",
  all_class: "Any class",
  adt_main_label: "Adult",
  inf_main_label: "Infant",
  chd_main_label: "Child",
  adt_second_label: "over 12 years old",
  chd_second_label: "2-12 years old",
  inf_second_label: "up to 2 years (without seat)",
  inf_with_seat_second_label: "with seat",
  passenger_1: "One passenger",
  passenger_2: "Two passengers",
  passenger_3: "Three passengers",
  passenger_4: "Four passengers",
  passenger_5: "Five passengers",
  passenger_6: "Six passengers",
  agents: "For agents",
  passenger_7: "Seven passengers",
  passenger_8: "Eight passengers",
  passenger_9: "Nine passengers",
  only_there: "One way",
  roundtrip: "Round trip",
  your_profile: "Your profile",
  client_name: "Client name",
  client_code: "Client code",
  partner_code: "Partner code",
  partner_name: "Partner name",
  partner_currency: "Partner currency",
  current_balance: "Actual balance",
  debt: "Debt",
  credit_limit: "Credit limit",
  deposit: "Deposit",
  change_password: "Change password",
  old_password: "Enter actual password",
  new_password: "New password",
  confirmation_password: "Confirm password",
  save: "Save",
  passwords_must_match: "Passwords must match",
  password_changed_successfully: "Password changed successfully",
  departure_title: "Departure",
  there_title: "There",
  back_title: "Back",
  validates_flights: "validates flights",
  pay_for_your_reservation: "to pay for the booked order",
  hour_short: "h",
  day_short: "d",
  minutes_short: "m",
  minutes_short_3: "min",
  on_way: "On the way",
  no_transfers: "Direct flight",
  class: "Class",
  tariff_options: "Tariff options",
  with_luggage: "With baggage",
  without_luggage: "Without baggage",
  quick_picks_title: "Quick picks",
  quick_optimal: "Best value",
  quick_cheapest: "Cheapest",
  quick_fastest: "Fastest",
  quick_transfers: "{{count}} stop(s)",
  quick_pick_hint: "Show in list",
  hours_short: "h",
  airline_combination: "Airline combination",
  with_airline_combination: "Combinations",
  without_airline_combination: "Single ticket",
  vtrip_notice: "This trip is issued as separate tickets. Their refunds and exchanges are handled independently. If the schedule changes or the flight is cancelled on one ticket, the refund or exchange of the other ticket is treated as voluntary, under its fare rules.",
  no_timelimit: "No payment time limit information",
  legal_information: "Legal information",
  opportunities: "Opportunities",
  same_routes: "🔗 Similar routes",
  tajikistan_attractions: "Attractions of Tajikistan",
  routes: "Routes",
  rules_of_use: "Rules of use",
  privacy_policy: "Privacy Policy",
  payment: "Payment",
  provider: "Supplier",
  price: "Price",
  detail: "More info",
  label_price_by_min: "Price (increase)",
  label_price_by_max: "Price (descrease)",
  transfers: "Transfers",
  all_flights: "All flights",
  without_transfers: "Direct flight",
  one_transfer: "1 transfer",
  many_transfer: "2 transfers and more",
  not_found_recomm_first_text: "We could not find tickets matching Your request ",
  not_found_recomm_second_text: "Please try again with others dates or airport ",
  not_found_recomm_by_filters: "Please change the filter conditions",
  flight_details: "Flight details",
  change_tariff: "Change tariff",
  tariffs: "Tariffs",
  teh_stop: "Technical stop",
  transfer: "Transfer",
  local_time_message: "Local departure and arrival times",
  route_tariffs_message: "The tariff is valid for the entire route",
  airlines: "Airlines",
  airports: "Airports",
  departure: "Departure",
  arrival: "Arrival",
  departure_time: "Departure time",
  arrival_time: "Arrival time",
  flight_number: "Flight number",
  multiple_numbers_separated_by_spaces: "Multiple numbers separated by spaces",
  lowcost: "lowcost",
  transfer_1: "transfer",
  transfer_2_4: "transfers",
  transfer_5: "transfers",
  free_seats_0: "no free seats",
  free_seats_1: "seat",
  free_seats_2_4: "seats",
  free_seats_5: "seats",
  one_adt: "Adult",
  more_adt: "Adults",
  many_adt: "Adults",
  one_chd: "Child",
  more_chd: "Children",
  many_chd: "Children",
  one_inf: "Infant",
  more_inf: "Infants",
  many_inf: "Infants",
  flight_one: "flight",
  flights_more: "flights",
  flights_many: "flights",
  found_one: "Found",
  found_more: "Found",
  flight_overview: "Flight overview",
  to_top: "Page up",
  book: "Booking",
  buyer: "Payer",
  pnr: "Booking code / PNR",
  online_registration_locator: "Online registration locator",
  route_information: "Flight information",
  order: "Order",
  flights_tickets: "Tickets",
  void_text: "You can cancel the order at any time",
  void_order: "Cancel the order",
  support_chat: "Support chat",
  payment_method: "Payment options",
  payment_with_balance: "Pay with balance",
  payment_with_card: "Pay by card",
  info_account: "Info account",
  get_tickets: "Issue tickets",
  left_before_the_time_limit: "Left time",
  expires: "Ends",
  payment_timed_out: "Time for payment is up",
  cashback_label: "Cashback",
  cashback_accrued_label: "Cashback credited",
  cashback_hint: "Cashback will be credited to your account balance after departure (registered users only)",
  time_expired: "Time is up",
  order_created: "Order created",
  return_ticket: "Return ticket",
  exchange_ticket: "Exchange ticket",
  download_itinerary_receipt: "Download itinerary receipt",
  order_cost: "Order price",
  invoice_for_payment: "Invoice",
  void_in_process: "Goes order cancellation",
  initial: "Order created",
  in_progress: "Booked",
  success: "Successful payment, tickets issued",
  partially_success: "Partially successful order",
  booking_fail: "Booking error",
  order_fail: "Error creating order",
  pay_fail: "Payment error",
  order_cancel_from_client: "Order canceled by customer",
  order_cancel_from_admin: "Order canceled by administrator",
  order_cancel_by_job: "Order canceled by time limit",
  order_cancel_error: "Error canceling order",
  application_refund: "Refund application is created",
  partial_refund: "Partial order refund",
  order_cancel_by_gds: "Order canceled by time limit",
  refund: "Full order refund",
  ticketing_done: "Successful payment, tickets issued",
  pay_success: "Successful payment, tickets are issuing",
  booking_done: "Booked",
  exchange: "Ticket exchange",
  void: "Order canceled",
  ticketing_fail: "Error issuing tickets",
  year_one: "year",
  year_more: "years",
  years: "years",
  day_one: "day",
  day_more: "days",
  days: "days",
  hour_one: "hour",
  hour_more: "hours",
  hours: "hours",
  minute_one: "minute",
  minute_more: "minutes",
  minutes: "minutes",
  second_one: "second",
  second_more: "seconds",
  seconds: "seconds",
  passenger_list: "Passenger list",
  your_name: "Your name",
  search_order: "Search order",
  locator: "Locator",
  cancel: "Cancel",
  passenger_name: "Passenger last name",
  do_not_find_order_message: "Order not found. Please change your search options",
  orders: "Orders",
  contract_settings: "Contract settings",
  main: "Main",
  users: "Users",
  affiliated_companies: "Affiliated companies",
  all_orders_label: "All orders",
  book_done_label: "Booked",
  pay_done_label: "Paid",
  ticket_done_label: "Ticketed",
  cancel_done_label: "Canceled",
  wait_refund_label: "Waiting for refund",
  refund_done_label: "Refunded",
  partial_refund_done_label: "Partially refunded",
  void_done_label: "Void",
  error_order_label: "Order error",
  date_create_from: "Creation date from",
  order_status_label: "Order status",
  search_title: "Enter last name, locator or city",
  date_create_to: "Creation date to",
  clear: "Clear",
  passenger_success_save: "Passenger saved successfully",
  payment_with_dpt: "Pay with balance",
  payment_with_unt: 'Pay with "Uniteller"',
  payment_with_spt: 'Pay with "Corti Milli"',
  include_your_fees: "includes your fee",
  before: "to",
  your_fees: "Your fee",
  month_one: "month",
  months_more: "months",
  months: "months",
  all_passengers: "All passengers",
  passenger_success_remove: "Passenger deleted successfully",
  companies: "Сompanies",
  no_companies: "No companies",
  no_matches_found: "No matches found",
  no_passengers: "You have no saved passengers yet",
  enter_passenger_name: "Enter passenger's first or last name",
  add_passenger: "Add passenger",
  your_partner_fees: "Your fee",
  type_of_fee: "Type of fee",
  value: "Value",
  percent: "Percent",
  saved_successfully: "Saved successfully",
  error_saving: "Saving error",
  percent_from_total: "Percent from total",
  percent_from_fare: "Percent from fare",
  fix_flat: "Fix flat",
  fix_flat_and_percent_from_total: "Fix flat and percent from total",
  fix_flat_and_percent_from_fare: "Fix flat and percent from fare",
  reset: "Reset",
  invalid_value: "Invalid value",
  no_orders_found: "No orders found",
  personal_data: "Personal data",
  upload: "Upload",
  your_logo: "Your logo",
  image_uploaded_successfully: "Image uploaded successfully",
  upload_logo: "Upload logo",
  image_too_large: "Image too large",
  image_resolution_too_high: "Image resolution too high",
  image_resolution_too_small: "Image resolution too small",
  rule_for_upload_img_1: "Image format .jpg, .png, .jpeg, .gif",
  rule_for_upload_img_2: "Resolution from 300x100px to 2000x2000px.",
  rule_for_upload_img_3: "File size no more than 4 MB.",
  amount: "Amount",
  rules_text_1: "Pay attention to the following phrases in the section",
  rules_text_2: "non refundable ticket",
  rules_text_3: "ticket is non-refundable in case of no-show",
  rules_text_4: "Exchange rules are described in the subtitled section",
  line: "Line",
  rules_text_5: "means that changes are not allowed so it's impossible to change flight dates",
  passenger_data: "Passenger data",
  comment: "Comment",
  contact_details: "Contact details",
  contact_information: "Contact information",
  remove: "Delete",
  add_document: "Add document",
  return_avia_rules: "How to exchange or return",
  booking_avia_rules: "How to book a ticket",
  created_at: "Created",
  updated_at: "Updated",
  phone: "Phone",
  create_user: "Create user",
  add: "Add",
  edit: "Edit",
  confirm: "Confirm",
  successfully_deleted: "Deleted successfully",
  error_deleting: "Deleting error",
  mess_want_to_delete: "Do you want to delete",
  record_one: "record",
  record_more: "records",
  record_many: "records",
  user_type: "Client type",
  admin_role: "Admin",
  manager_role: "Manager",
  user_agent_role: "Agent",
  user_role: "User",
  security_guarantees_unitaller: "Security guarantees",
  activation_title: "User Activation",
  confirmation_activation_password: "Confirm password",
  enter_activation_password: "Enter password",
  activation: "Activation",
  login: "Login",
  error_activating_user: "Error activating user",
  error: "Error",
  to_login_form: "To login page",
  expired_date: "Expired",
  refund_button_title: "Refund",
  itinerary_receipt: "Itinerary receipt",
  action: "Action",
  to_pay: "Payment",
  order_cancel_error_mess: "Error cancelling order",
  order_cancel_successfully_mess: "Cancellation successful",
  partner: "Partner",
  inn: "INN",
  kpp: "KPP",
  logo: "Logo",
  create_partner: "Create a partner",
  status: "Status",
  add_your_details: "Add your details",
  return_request_created: "Refund application is created",
  error_creating_refund_request: "Error creating refund application",
  activation_status: "Activation status",
  placeholder_date_picker: "dd.mm.yyyy",
  created_company_successfully: "Company created",
  error_created: "Error creating",
  deposit_statement: "Deposit statement",
  transactions: "Transactions",
  weight_unit: "kg",
  credit_funds: "Credit funds",
  overrun: "Overrun",
  transaction_time: "Transaction time",
  before_balance_change: "Before balance change",
  allow_balance_payment: "Allow balance payment",
  approved_balance_request_successfully: "Application for statement of balance confirmed",
  error_approved_balance_request_successfully: "Error confirming application for statement of balance",
  balance_payment_request: "Balance payment request",
  balance_payment_approved: "Balance payment approved",
  payment_with_uzc: 'Pay with "Uzcard"',
  allow_payment: "Allow payment",
  statement_request: "Statement request",
  client: "Client",
  was_changed_to: "was changed to",
  deposit_statement_request_created: "Deposit statement request created",
  registration: "Registration",
  error_creating_deposit_statement_request: "Error creating deposit statement request",
  deposit_statement_request_confirmed: "Deposit statement request confirmed",
  error_confirming_deposit_statement_request: "Error confirming deposit statement request",
  fare: "Fare",
  fees: "Fees",
  partner_fees: "Partner fees",
  taxes: "Taxes",
  ticket: "Ticket",
  pay_for_the_order: "Pay for the order",
  operating_company: "Operating company",
  download_charter_certificate: "Download charter certificate",
  certificate_issued: "Charter certificate issued",
  charter: "Charter",
  service: "Service",
  income: "Income",
  spending: "Spending",
  remainder: "Remainder",
  description: "Description",
  contract: "Contract",
  column_selection: "Column selection",
  your_commission: "Your commission",
  no_result: "No result",
  date: "Date",
  movement_balance: "Movement of funds on balance",
  current_balance_sheet: "Current balance sheet",
  indebtedness: "Indebtedness",
  date_from_d: "Date from",
  date_to_d: "Date to",
  order_num: "Order number",
  order_details: "Order Details",
  flight_info: "Flight Info",
  price: "Price",
  status: "Status",
  orders_subtitle: "View and manage your flight bookings",
  successful: "Successful",
  cancelled: "Cancelled",
  timeout: "Timeout",
  success: "Success",
  order_cancelled_by_customer: "Order cancelled by customer",
  order_cancelled_by_time_limit: "Order cancelled by time limit",
  successful_payment_tickets_issued: "Successful payment, tickets issued",
  status_refund: "Refund",
  status_exchange: "Exchange",
  status_void: "Voided",
  status_error: "Error",
  status_pending: "Pending",
  status_processing: "Processing",
  status_booked: "Booked",
  booking_num: "Reservation number",
  search_operations: "Search operations",
  upload_report: "Upload report",
  payment_with_vsl: 'Pay with "Corti Milli"',
  popular_destinations: "Popular destinations",
  more_options: "More options",
  hide_list: "Hide the list",
  straight: "Straight",
  with_transfer: "With transfers",
  finances: "Finance",
  contacts: "Contacts",
  all_classes: "All classes",
  difficult_routes: "Make a difficult route",
  search_history: "Search history",
  go_to_page: "Go over",
  find_tickets: "Find tickets",
  tours_discount: "Favorable tours and discounts",
  last_news: "Last news",
  more_details: "More details",
  about_company: "About company",
  wannatalk: "Want to talk?",
  customer_rew: "Customer reviews",
  my_profile: "My profile",
  contact_us: "Contact us",
  last_name: "Last name",
  first_name: "First name",
  father_name: "Middle name",
  enter_login: "Enter your login",
  enter_name: "Enter your name",
  enter_surname: "Enter your last name",
  enter_fathname: "Enter your father name",
  aeroflot: "Aeroflot",
  uz_airways: "Uzbekistan Airways",
  turkish: "Turkish Airlines",
  ural: "Ural Airlines",
  korea: "Korean Air",
  qanot: "Qanot Sharq",
  belavia: "Belavia",
  apgAS: "APG Air Solution",
  pobeda: "Pobeda",
  airastana: "Air Astana",
  flyaristan: "Fly Aristan",
  s7: "Siberian Airlines",
  enter_password: "Enter your password",
  flight_search: "Flight search",
  buy_air_tickets: "Buy air tickets without leaving home",
  log_in: "Log in",
  welcome_back: "Welcome back!",
  return_to_simple_route: "Return to simple route",
  delete: "Delete",
  max_num_flights: "You added maximum number of flights",
  select_dep_date: "Select departure date",
  select_return_date: "Select return date",
  select_class: " Select class",
  login_as_user: "Please enter your credentials below to access your account.",
  enter_recieved_code: "Enter the recieve code",
  come_up_your_pass: "Come up with your password",
  enter_valid_mail: "Enter valid email",
  must_field_characters: "Field must contain at least 6 characters",
  register_to_save_data: "Register to save your information",
  ins_main_label: " Infant",
  ins_second_label: " up to 2 years (with seat)",
  newsletter_subscription: "Newsletter subscription",
  newsletter_subscription_text: "Subscribe to keep abreast of all important news and great deals!",
  subscribe: "Subscribe",
  successfully_subscribed: "You have successfully subscribed!",
  subscription_error: "Subscription error, please try again later!",
  all_news: "All news",
  tel: "Tel",
  enter_email: "Enter your email",
  menu: "Menu",
  settings: " Settings",
  deposit_method: "Select deposit method",
  recharging_amount: "Recharging amount",
  recharge: " Recharge",
  recharging_balance: "Recharging balance",
  done: " Done",
  not_found_content: " Not found",
  not_found_content_text: " Unfortunately, this content is not available in the selected language",
  airport_code: "Airport code",
  from_city: "From",
  to_city: "To City",
  weekdays: "Days of the week",
  weekends: "Weekwnds",
  weekends1: "January 1 and 2",
  weekends2: "March 8",
  weekends3: "March 21 to 24",
  weekends4: "May 9",
  weekends5: "June 27",
  weekends6: "September 9",
  weekends7: "November 6",
  weekends8: "As well as during Eid holidays",
  airline: "Airline",
  min_number: "Amount must be greater than",
  only_numbers: " Only numbers",
  must_register: " In order to buy tickets on our website, you must be logged in",
  daily: "Daily",
  fly_tagline: "It's easy to fly with us",
  sorting: "Sorting",
  i_read_fares: "I read",
  i_accept_fares: "and I accept them all",
  prices_table: "Prices table",
  continue: "Continue",
  reset_error_title: "Error",
  reset_error_content: "Sorry, error occured while processing your request",
  reset_success_title: "You successfully changed your password",
  page_my_transactions: "Reporting on completed payments",
  reset_success_content: 'Please, click on "Login" button to log in with new password',
  forgot_success_title: "Success!",
  forgot_success_content: "Reset link has been sent to your E-Mail",
  forgot_error_title: "Error",
  forgot_error_content: "Sorry, but you entered wrong E-Mail",
  password_confirm: "Password Confirmation",
  password_confirm_error: "Passwords aren't the same",
  enter_password_confirm: "Confirm the password",
  reset_password: "User password reset",
  mail_sent: "Mail sent!",
  enter_new_password: "Please enter your new password",
  forgot_password: "Forgot Password?",
  forgot_password_summary: "Enter your E-Mail to reset your password",
  password_recovery_text:
    "Enter the e-mail address registered on our website. We will send you a link to restore access",
  password_recovery_confirm_text: "We've sent you an email with a link to restore it",
  popup_event_text: "Get a bonus of 100 somoni on the balance of your personal account after registration",
  popup_description: "Register on the site and buy tickets online without leaving your home!",
  payment_milly: 'Payment by "Korti milli"',
  from_airport: "From airport",
  not_enough_balance: "Balance isn't enough for payment",
  questions_and_answers: "Questions and answers",
  payment_methods: "Payment Methods",
  our_partners: "Our partners",
  confirm_actions: "Confirm your action on the site",
  payer_contacts: "Payer contacts",
  buyer_email: "Buyer email",
  enter_buyer_email: "Enter buyer email",
  locator_order_number_or_booking_number: "Locator, order number or booking number",
  enter_locator_order_number_or_booking_number: "Enter locator, order number or booking number",
  activate: "Activate",
  register: "Register",
  deals: "Deals",
  pre_cashback: "Buy air tickets and get a fixed",
  partners: "Partner airlines",
  scoreborad: "Online airport board",
  cashback0: "Direct contract. Prices from airlines",
  cashback_from:
    "Cashback from the project partner airlines is applied to flights from Uzbekistan airports. Cashback is calculated from the fare.",
  cashback_from_in:
    "Cashback from airlines of the project partners is applied to flights from/to airports of Uzbekistan. Cashback is calculated from the fare.",
  tarif: "from fare",
  post_cashback: "to the balance of your personal account",
  cashback_message: "To receive cashback, you need to register on the site and purchase tickets through our service. ",
  cashback_message_auth: "The following cashback offers are available to you:",
  page_home: "Online ticket purchase, without visiting the ticket office.",
  page_faq: "Answers to popular questions",
  page_login: "Log in to your personal account",
  page_registration: "Register and buy tickets",
  page_results: "Results for the route of interest",
  page_booking: "Booking a given ticket",
  page_order: "Information about the completed order",
  page_orders_list: "Information about completed orders",
  page_my_profile: "Personal information",
  page_add_balance: "Replenishment of the balance of the personal account",
  page_popular_destinations: "Popular departures schedule",
  page_news: "Popular aviation news and Fly TJ",
  page_forgot_password: "Buying air tickets Online without leaving your home!",
  page_reset_password: "Buying air tickets Online without leaving your home!",
  useful_info: "Useful information",
  copy_link: "Copy link",
  copy_order_link_text: "Copy the link to share access to this order",
  link_copied_to_clipboard: "Link copied to clipboard",
  unsubscribe_success: "You unsubscribed successfully",
  unsubscribe_error: "Error occured while processing the request",
  activation_code_send_to_email: "A confirmation code will be sent to your email address",
  choose_gender: "Choose gender",
  old_information: "Information is out of date!",
  refresh: "Refresh",
  refresh_page: "Airfare prices are updated several times a day. Refresh the page to check the current prices.",
  will_take_2_minutes: "It can take some time",
  error_additional_options_text:
    "An error occurred while enabling additional options for booking. Continue without additional options?",
  edit_personal_data: "Edit your personal data",
  minimum_amount: "Minimum amount",
  additional_options: "Additional options",
  additional_options_not_found: "Additional options not found!",
  profile_changed: "Profile changed successfully",
  welcome: "Welcome",
  register_on_somon_air: "Register on Somon Air",
  min_6_symbol: "6 characters minimum",
  your_id: "Your ID",
  cheapest_without_baggage: "Cheapest without baggage",
  cheapest_with_baggage: "Cheapest with baggage",
  most_convenient_transfes: "The most convenient transfer",
  fly_ru_tagline: "Taste the world!",
  fly_ru_subtagline: "Your access to all airlines in the world",
  fly_ru_round_the_clock: "24/7",
  refund_order: "Refund statement",
  refund_reason: "Refund reason",
  order_payment_method: "Order payment method",
  payer_user_id: "Payer's ID",
  four_last_digits_of_card: "Last 4 digits of card",
  user_id: "User's ID",
  buyer_phone: "Buyer's phone",
  requisite_of_account_to_return: "Bank account number for returning money",
  requisite_of_account: "Bank account number",
  passenger_name_and_surname: "Full name of the passenger",
  passport_serial_and_number: "Series and passport number",
  passport_copy: "Passport copy",
  send: "Send",
  payment_from_client_balance: "Payment via balance",
  payment_from_card: "Payment via card",
  vasl_tagline: "Convenience is a priority!",
  technical_support: "Technical Support",
  success_refund_order_request: "Refund request sent successfully!",
  error_refund_order_request: "Error submitting refund request!",
  find_options: "Find options",
  buy_tickets_to_all_destinations: "and buy tickets to all destinations!",
  filters: "Filters",
  operation_type: "Operation type",
  all_operations: "All operations",
  balance_operation: "Balance operation",
  order_payment: "Order payment",
  apply_filters: "Apply Filters",
  export: "Export",
  view_manage_transactions: "View and manage your transaction history",
  no_transactions: "You have no transactions!",
  showing: "Showing",
  of_total: "of",
  transactions_count: "transactions",
  previous: "Previous",
  next: "Next",
  date_and_time: "Date & Time",
  merchant: "Merchant",
  type: "Type",
  search_by_order: "Search by order...",
  recharge_balance: "Recharge Balance",
  add_funds_securely: "Add funds to your account securely",
  select_payment_method: "Select Payment Method",
  quick_amounts: "Quick amounts",
  important_information: "Important Information",
  minimum_recharge: "Minimum recharge",
  maximum_recharge: "Maximum recharge",
  processing_time: "Processing time",
  instant: "Instant",
  no_additional_fees: "No additional fees",
  recent_recharges: "Recent Recharges",
  no_recent_recharges: "No recent recharges",
  max_number: "Amount must be less than",
  night_flight: "Night transfer",
  change_airport: "Change airport",
  and: "and",
  from: "from",
  refund_order_success: "Refund application sent successfully",
  refund_order_error: "Error occured while sending application",
  buy_tour: "Buy tour",
  payment_alert: "Dear user, your order has been paid.  Extraction time 1 minute.",
  customer_office_address: "Customer office address",
  inner_document: "Internal document",
  inner_links: "Recommend to read",
  document_copy: "Copy of document",
  maximum_amount: "Maximum amount",
  search_limits_exceeded: "Dear user, you exceeded search limit, please authorize in order to continue",
  flight_without_seats: "We are sorry, we are out of seats on this flight.",
  document_type: "Document type",
  document_number: "Document number",
  expiration_date: "Expiration date",
  any_cabin: "Any class",
  my: "My",
  site: "Site",
  show_more: "Show more",
  route: "Route",
  pay_before: "Pay before",
  price_expired_title: "Prices expired",
  price_expired_text: "Prices may have expired during your absence, refresh the page to see the latest prices.",
  price_expired_button: "Update Page",
  price_changed_title: "Price has changed",
  price_changed_text_up: "While you were completing the order, the airline changed the fare. The new price is higher than before.",
  price_changed_text_down: "While you were completing the order, the airline changed the fare. The new price is lower than before.",
  price_changed_old: "Previous price",
  price_changed_new: "New price",
  price_changed_question: "Continue with the new price?",
  price_changed_agree: "Agree, continue",
  price_changed_disagree: "Disagree, back to search",
  price_changed_moved_again: "The price has changed again. Check the new amount and confirm once more.",
  price_changed_update_error: "Could not update the price. Please try again.",
  price_changed_loading: "Updating price…",
  price_changed_prebook_text_up: "Since your search the airline has changed the fare for this flight. The new price is higher.",
  price_changed_prebook_text_down: "Since your search the airline has changed the fare for this flight. The new price is lower.",
  price_changed_prebook_question: "Continue booking at the new price?",
  price_changed_prebook_disagree: "Disagree, refresh search",
  prebook_flight_unavailable: "The flight is no longer available: there are no seats or the selected fare left. Please search again.",
  prebook_error_title: "Flight loading error",
  prebook_error_search_again: "Search again",
  get_visa_title: "Let's tell you if you need a visa",
  get_visa_subtitle: "Indicate where you're going",
  get_visa_result_title: "Are you ready to learn about visa requirements?",
  get_visa_result_desc: "Choose your citizenship and destination country to get up-to-date visa information",
  select_citizenship: "Choose your citizenship",
  select_placeholder_citizenship: "Your citizenship",
  select_destination: "Choose destination country",
  select_placeholder_destination: "Destination country",
  get_visa_loading_message: "Checking visa requirements...",
  in_house: "No visa required for domestic flights",
  no_country: "Country not found",
  no_data: "No data available.",
  check_console_website: "Please check the consulate website.",
  no_visa: "No visa required",
  no_visa_14: "No visa required for up to 14 days",
  no_visa_15: "Visa is not required for up to 15 days",
  no_visa_21: "No visa required for up to 21 days",
  no_visa_28: "Visa is not required for up to 28 days",
  no_visa_30: "Visa is not required for up to 30 days",
  no_visa_60: "No visa required for up to 60 days",
  no_visa_90: "No visa required for up to 90 days",
  no_visa_180: "No visa required for up to 180 days",
  no_visa_360: "No visa required for up to 360 days",
  no_restrictions: "No restrictions on entry",
  visa_on_arrival: "Visa on arrival",
  visa_on_arrival_desc: "Is being processed under passport control",
  e_visa: "Electronic visa",
  visa_required: "Requires a visa",
  check_council: "Check the terms on the Consulate website",
  to_pay_title: "Total to be paid",
  flight_selection: "Flight selection",
  passenger_details: "Passenger details",
  base_fare: "Base fare",
  taxes_and_fees: "Taxes and fees",
  includes_service_charges: "Includes service charges",
  allowed: "Allowed",
  non_refundable: "Non-refundable",
  non_exchangeable: "Non-exchangeable",
  contact_operator: "Contact operator",
  direct_flight: "Direct flight",
  processing: "Processing",
  copyright: "© 2026 Skyrix.dev. All rights reserved.",
  services_in_development_title: "Page under development",
  services_in_development_description: "We are actively working on this section. New services and features will appear here very soon. Stay tuned!",
  not_found_title: "Page not found",
  not_found_description: "It looks like this flight has been cancelled. Check the address or go back to the homepage to find a new destination!",
  go_to_home: "Go to homepage",
  login_exist: "A user with this E-mail already exists!",
  unable_to_send_email: "Failed to send email. Please try again later.",
  baggage_not_included: "Baggage not included",
  hand_luggage_not_included: "Hand luggage not included",
  clarify_weight_contact_operator: "To clarify the exact weight of hand luggage or baggage, please contact the operator",
  registration_error: "Registration error. Please try again later.",
  incorrect_client_login: "Invalid login or password",
  not_exist_or_not_active_user: "User not found or not activated",
  password_reset_error: "Password reset error. Please try again later.",
  new_password_saved: "New password saved successfully!",
  can_login_with_new_password: "You can log in using your new password",

  // About page
  about_hero_title_1: "About",
  about_hero_subtitle: "S-Service LLC is the representative office of Somon Air airline in Moscow and the Moscow region.",
  about_stat_founded: "Year founded",
  about_stat_customers: "Happy customers",
  about_stat_airlines: "Airline partners",
  about_stat_support: "Customer support",
  about_mission_title: "Our tasks and functions",
  about_mission_text_1: "Our tasks and functions are to represent the airlines in the aviation market and to organise passenger and cargo transportation from Domodedovo Airport.",
  about_mission_text_2: "S-Service has been operating in the aviation market since 2011.",
  about_history_title: "About us",
  about_history_text_1: "The representative office of Somon Air and Tajik Air in Moscow and the Moscow region was established and operates with the following goals:",
  about_history_text_2: "— to protect the interests of the airlines in the Moscow region.",
  about_history_text_3: "— to represent the airlines at Domodedovo Airport, including as an agent for the sale of passenger transportation.",
  about_values_title: "Our values",
  about_value_1_title: "Best prices",
  about_value_1_text: "We aggregate offers from leading airlines so you always find the most competitive fares.",
  about_value_2_title: "Security",
  about_value_2_text: "Your data and payments are fully protected. We only work with verified payment systems.",
  about_value_3_title: "24/7 support",
  about_value_3_text: "Our team is ready to help you at every step — from choosing a flight to receiving your boarding pass.",
  about_cta_title: "Ready to fly?",
  about_cta_text: "Find the best flight tickets right now and set off on your dream trip.",
  about_cta_button: "Find tickets",

  why_us_title: "Why buy from us",
  why_us_item_1: "Official Somon Air agent in Russia",
  why_us_item_2: "24/7 passenger support",
  why_us_item_3: "Payment with Russian bank cards",
  why_us_item_4: "E-ticket in 1 minute",
  why_us_button: "Contact support",

  trust_title: "They trust us",
  trust_stat_tickets: "tickets sold",
  trust_stat_years_unit: "years",
  trust_stat_years: "in the aviation market",
  trust_stat_support: "passenger support",
  trust_button: "Buy a ticket",
  copy_text: "Copy text",
  text_copied: "Copied",
  // заявка на возврат
  refund_request_subtitle: "Fill in the form and attach your refund application. We will check the order and contact you.",
  order_number_label: "Order number",
  enter_order_number: "Enter the order number",
  enter_refund_reason: "Describe the reason for the refund",
  refund_requisites_hint: "For example: card or account number, bank, recipient",
  refund_document: "Refund application / copy of document",
  refund_document_hint: "PDF, DOC, DOCX, JPG or PNG, up to 10 MB",
  choose_file: "Choose file",
  file_not_chosen: "No file chosen",
  file_required: "Please attach a file",
  file_too_large: "File is larger than 64 MB",
  file_wrong_format: "Unsupported file format",
  refund_request_sent_text: "We have received your request. The order status will change to «Refund requested», we will contact you after review.",
  refund_status_not_suitable: "A refund request is not available for this order: tickets are not issued yet or a refund is already in progress.",
  refund_passengers_label: "Passengers to refund",
  refund_passenger_refunded: "Refunded",
  refund_passenger_in_request: "Request already sent",
  refund_passengers_hint: "Check the passengers to refund. An infant is refunded together with an adult.",
  refund_select_passenger_required: "Select at least one passenger",
  refund_infant_without_adult: "An infant cannot stay in the order without an adult: refund the infant together with the adult.",
  refund_passengers_invalid: "The selected passengers are already refunded or do not belong to the order.",
  to_orders: "To my orders",
  request_refund: "Request a refund",
  optional_field: "optional",
  payment_commission_title: "The amount to pay has changed",
  payment_commission_text: "When paying with “{{method}}”, the payment system charges a fee. It has been added to the order amount.",
  payment_commission_order_amount: "Order amount",
  payment_commission_fee: "Payment system fee",
  payment_commission_total: "To pay",
  payment_commission_hint: "You can choose another payment method with a lower fee or no fee.",
  payment_commission_ok: "Got it",
  payment_commission_choose_other: "Choose another method",
  payment_commission_to_pay: "To pay including fee",
  // дополнительные услуги к заказу (eSIM, багаж и т.п.)
  additional_options_hint: "Can be added to the order before payment. Services are issued after payment, documents arrive together with the ticket.",
  add_option: "Add",
  remove_option: "Remove",
  price_on_request: "Price on request",
  additional_options_error: "Could not update additional services, please try again",
  additional_options_total: "Additional services",
  additional_options_price_changed: "The price of additional services has changed. Check the new order total and pay again.",
  seats_choose: "Choose seats",
  seats_hide_map: "Hide seat map",
  seats_not_selected: "No seats selected",
  meal_current_replace: "Current: {{meal}} — choosing another one will replace it",
  seat_not_selected: "no seat selected",
  seat_free_of_charge: "Free of charge",
  seat_occupied: "Occupied",
  seat_exit_row: "emergency exit",
  passenger: "Passenger",
  payment_checking_notice: "We are checking your payment. If you have already paid, please do not pay again — the order status will update automatically.",
};

export default en;
